import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>

        {/* BRAND */}
        <div className={styles.brand}>
          <div className={styles.logo}>
            Rising<span>DSP</span>
          </div>
          <p>© {new Date().getFullYear()} RisingDSP. All rights reserved.</p>
        </div>

        {/* LINKS */}
        <div className={styles.links}>
          <h3>Company</h3>
          <Link to="/imprint">Imprint</Link>
          <Link to="/termsCondition">Terms & Conditions</Link>
          <Link to="/privacyPolicy">Privacy Policy</Link>
          <Link to="/about">About</Link>
        </div>

        {/* SOCIAL */}
        <div className={styles.social}>
          <h3>Follow on</h3>

          <div className={styles.icons}>

            {/* X (Twitter) */}
            <a href="https://x.com/RisingDSP" target="_blank" rel="noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.9 2H22l-6.8 7.8L23 22h-6.2l-4.9-6.3L6.3 22H2l7.3-8.4L1 2h6.3l4.4 5.8L18.9 2zm-1.1 18h1.7L6.1 3.9H4.3L17.8 20z"/>
              </svg>
            </a>

            {/* TikTok */}
            <a href="https://www.tiktok.com/@risingdsp" target="_blank" rel="noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 3c.4 2.1 1.9 3.6 4 4v3c-1.5 0-2.9-.5-4-1.3V15a6 6 0 1 1-6-6c.4 0 .7 0 1 .1v3a3 3 0 1 0 3 3V3h2z"/>
              </svg>
            </a>

            {/* Instagram */}
            <a href="https://www.instagram.com/risingdsp/" target="_blank" rel="noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm5 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm6.5-.9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
              </svg>
            </a>

            {/* YouTube */}
            <a href="https://www.youtube.com/@risingdsp" target="_blank" rel="noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M21.6 7.2s-.2-1.5-.8-2.2c-.7-.9-1.5-.9-1.9-1C16.2 4 12 4 12 4s-4.2 0-6.9.2c-.4.1-1.2.1-1.9 1-.6.7-.8 2.2-.8 2.2S2 9 2 10.8v1.4C2 14 2.4 15.6 2.4 15.6s.2 1.5.8 2.2c.7.9 1.7.9 2.1 1 1.5.1 6.7.2 6.7.2s4.2 0 6.9-.2c.4-.1 1.2-.1 1.9-1 .6-.7.8-2.2.8-2.2s.4-1.6.4-3.4v-1.4c0-1.8-.4-3.6-.4-3.6zM10 14V8l6 3-6 3z"/>
              </svg>
            </a>

            {/* Facebook */}
<a href="https://www.facebook.com/people/Rising-DSP/61587123388369/" target="_blank" rel="noreferrer">
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 8h3V4h-3c-2.8 0-5 2.2-5 5v3H6v4h3v6h4v-6h3.5l.5-4H13V9c0-.6.4-1 1-1z"/>
  </svg>
</a>

          </div>
        </div>

      </div>
    </footer>
  );
}